module.exports = __webpack_public_path__ + "static/media/menu-button.3dc2f9b7.svg";